import React, { useEffect, useState } from "react";

const Reviews = () => {

  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    if (!document.querySelector('script[src="https://widget.clutch.co/static/js/widget.js"]')) {
      const clutchScript = document.createElement("script");
      clutchScript.src = "https://widget.clutch.co/static/js/widget.js";
      clutchScript.async = true;
      clutchScript.onload = () => setIsScriptLoaded(true);
      clutchScript.onerror = () => console.error("Failed to load Clutch widget script.");
      document.body.appendChild(clutchScript);
  
      return () => {
        document.body.removeChild(clutchScript);
      };
    } else {
      setIsScriptLoaded(true); // Script is already loaded
    }
  }, []);
  

  useEffect(() => {
    if (isScriptLoaded) {
      if (window.CLUTCHCO) {
        window.CLUTCHCO.Init();
      }
    }
  }, [isScriptLoaded]);

  return (
    <div style={{ margin: "20px auto 0" }}>
      {!isScriptLoaded ? (
        <p>Loading reviews...</p>
      ) : (
        <div
          className="clutch-widget"
          data-url="https://widget.clutch.co"
          data-widget-type="12"
          data-height="375"
          data-nofollow="true"
          data-expandifr="true"
          data-scale="100"
          data-reviews="20822,68143,143826,97682"
          data-clutchcompany-id="823646"
        ></div>
      )}
    </div>
  );
  
};

export default Reviews;
